const role = {
  state: {
    roleId: 0,
    roleName: ''
  },
  mutations: {
    setRoleId: (state, roleId) => {
      state.roleId = roleId
    },
    setRoleName: (state, roleName) => {
      state.roleName = roleName
    }
  },
  actions: {}
}
export default role
